module.exports = __webpack_public_path__ + "static/media/1beach_large.527cf77d.jpg";